import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get,post} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchServices = createAsyncThunk("fetchServices", (params, {dispatch}) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'services',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchServices.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchServices.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchServices.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
